module.exports = __webpack_public_path__ + "static/models/car_wheels.a7ca42e.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/car/car_wheels.json
// module id = 583
// module chunks = 1